import React, { useEffect, useState } from 'react';
import LayoffModal from './LayoffModal';
import SignerSelect from './SignerSelect';
import { useReassignSigner } from './useLayoff';
import styles from './layoff.module.scss';

const ReassignSignerModal = ({ layoff, onClose }) => {
  const [signerHash, setSignerHash] = useState('');
  const [tried, setTried] = useState(false);
  const reassign = useReassignSigner({ onSuccess: onClose });

  useEffect(() => {
    setSignerHash('');
    setTried(false);
  }, [layoff?.hash]);

  const submit = () => {
    setTried(true);
    if (signerHash) {
      reassign.mutate({ hash: layoff.hash, signerHash });
    }
  };

  return (
    <LayoffModal
      isOpen={!!layoff}
      title={`Reassign signer for ${layoff?.employee?.name ?? ''}`}
      onClose={onClose}
    >
      <p>
        Currently signs: <strong>{layoff?.signer || 'No signer'}</strong>
      </p>
      <label htmlFor='reassign-signer' className={styles.field_label}>
        New signer
      </label>
      <SignerSelect
        id='reassign-signer'
        value={signerHash}
        onChange={setSignerHash}
        invalid={tried && !signerHash}
        excludeHashes={layoff ? [layoff.employee.hash] : []}
      />
      {tried && !signerHash && (
        <span className={styles.error_text}>Choose who signs.</span>
      )}
      <p className={styles.hint}>
        The new signer is notified in the app and by email.
      </p>
      <div className={styles.modal_actions}>
        <button type='button' className='button grey' onClick={onClose}>
          Cancel
        </button>
        <button
          type='button'
          className='button'
          onClick={submit}
          disabled={reassign.isLoading}
        >
          {reassign.isLoading ? 'Saving...' : 'Reassign signer'}
        </button>
      </div>
    </LayoffModal>
  );
};

export default ReassignSignerModal;
